import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './infographic-page.component.scss';
var InfographicPage = /** @class */ (function (_super) {
    tslib_1.__extends(InfographicPage, _super);
    function InfographicPage(element) {
        return _super.call(this, element) || this;
    }
    InfographicPage.prototype.init = function () {
    };
    InfographicPage.prototype.bindEvents = function () {
    };
    return InfographicPage;
}(Base));
export { InfographicPage };



//////////////////
// WEBPACK FOOTER
// ./components/infographic-page/infographic-page.component.ts
// module id = 382
// module chunks = 0